/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { Link } from "react-router-dom";
import { Col, Row } from 'antd';
import "./style.scss";
import BannerLaunchpad from "../../../components/BannerLaunchpad";
import BannerDexSwap from "../../../components/BannerDexSwap";
import BannerDefai from "../../../components/Defai";
import BannerNFTMarket from "../../../components/BannerNFT";
import { DEFAI, LAUNCHPAD, NFT_URL, XCONNECT } from "../../../const/const";
const Produccts: React.FC = () => {
  return (
    <div id="products" className="products-layout">
      <div className="layout">
        <div className="inner-layout">
          <div className="product">
            <h4 className="title">OUR PRODUCTS</h4>
            <h2 className="name">The BSCS Ecosystem</h2>
            <Row className="product-row">
              <img className="top-left square" alt='' src='/images/footer/square.svg' />
              <img className="top-right square" alt='' src='/images/footer/square.svg' />
              <img className="bottom-left square" alt='' src='/images/footer/square.svg' />
              <img className="bottom-right square" alt='' src='/images/footer/square.svg' />
              <img className="bottom-center hide square" alt='' src='/images/footer/square.svg' />
              <img className="top-center hide square" alt='' src='/images/footer/square.svg' />
              <Col onClick={() => window.open(LAUNCHPAD)} className="left relative" xs={24} sm={24} lg={12}>
                {/* <img className="banner small" src='/images/home/products/1.png' /> */}
                <img className="bottom-left square" alt='' src='/images/footer/square.svg' />
                <img className="bottom-right square" alt='' src='/images/footer/square.svg' />
                <BannerLaunchpad />
                <div className="content">
                  <h2>[ launchpad ]</h2>
                  <p className="desc">Launch your project with BSCS’s multichain platform — a secure and scalable gateway for IDOs and INOs.</p>
                  <div className="flex space-between explore">
                    <a className="text" target="_blank" href={LAUNCHPAD}>Explore</a>
                    <a target="_blank" href={LAUNCHPAD}> <img src='/images/home/products/arrow.svg' /></a>
                  </div>
                </div>
              </Col>
              <Col onClick={() => window.open(XCONNECT)} className="right" xs={24} sm={24} lg={12}>
                {/* <img className="banner" src='/images/home/products/2.png' /> */}
                <BannerDexSwap />
                <div className="content">
                  <h2>[ XConnect ]</h2>
                  <p className="desc">Earn rewards by engaging on X (Twitter). Boost your rank, visibility, and airdrop chances through SocialFi.</p>
                  <div className="flex space-between explore">
                    <a className="text" target="_blank" href={XCONNECT}>Explore</a>
                    <a target="_blank" href={XCONNECT}> <img src='/images/home/products/arrow.svg' /></a>
                  </div>
                </div>
              </Col>
            </Row>
            <img className="horizon" src='/images/home/products/horizon.png' />
            <Row className="product-row bottom">
              <img className="bottom-left square hide" alt='' src='/images/footer/square.svg' />
              <img className="bottom-right square hide" alt='' src='/images/footer/square.svg' />
              <img className="bottom-center square hide" alt='' src='/images/footer/square.svg' />
              <img className="left-center square mobile" alt='' src='/images/footer/square.svg' />
              <img className="right-center square mobile" alt='' src='/images/footer/square.svg' />
              <Col onClick={() => window.open(NFT_URL)} className="left relative" xs={24} sm={24} lg={12}>
                {/* <img className="banner small" src='/images/home/products/3.png' /> */}
                <img className="bottom-left square" alt='' src='/images/footer/square.svg' />
                <img className="bottom-right square" alt='' src='/images/footer/square.svg' />
                <BannerNFTMarket />
                <div className="content">
                  <h2>[ nft marketplace ]</h2>
                  <p className="desc">Trade, collect, and explore NFTs across BSC in a seamless, user-friendly NFT hub.</p>
                  <div className="flex space-between explore">
                    <a className="text" target="_blank" href={NFT_URL}>Explore</a>
                    <a target="_blank" href={NFT_URL}> <img src='/images/home/products/arrow.svg' /></a>
                  </div>
                </div>
              </Col>
              <Col onClick={() => window.open(DEFAI)} className="right" xs={24} sm={24} lg={12}>
                {/* <img className="banner" src='/images/home/products/4.png' /> */}
                <BannerDefai />
                <div className="content">
                  <h2>[ defai ]</h2>
                  <p className="desc">AI-powered DeFi terminal that simplifies crypto trading and analytics with intelligent, real-time insights.</p>
                  <div className="flex space-between explore">
                    <a className="text" target="_blank" href={DEFAI}>Explore</a>
                    <a target="_blank" href={DEFAI}> <img src='/images/home/products/arrow.svg' /></a>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Produccts;
